import * as constants from '../constants/constants';

const defaultStore = {
  selectedComplex: null,
  complexes: [],
  isLoadingComplexes: false,
  isShowCreateComplexModal: false,
  isShowDeletePopup: false,
  deletingComplexId: '',
  deletingComplexName: '',
  complexStatus: [],
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case constants.GET_COMPLEXES_LOADING:
      return {
        ...state,
        selectedComplex: null,
        complexes: [],
        isLoadingComplexes: true,
      };
    case constants.GET_COMPLEXES_SUCCESS:
      return {
        ...state,
        complexes: action.payload.complexes,
        isLoadingComplexes: false,
      };
    case constants.SET_COMPLEX_STATUS:
      return {
        ...state,
        complexStatus: action.payload.status,
      };

    case constants.GET_COMPLEXES_ERROR:
      return {
        ...state,
        selectedComplex: null,
        complexes: [],
        isLoadingComplexes: false,
      };
    case constants.SELECT_COMPLEX:
      return {
        ...state,
        selectedComplex: action.payload.complex,
      };
    case constants.TOGGLE_CREATE_COMPLEX_MODAL:
      return {
        ...state,
        isShowCreateComplexModal: !state.isShowCreateComplexModal,
      };
    case constants.TOGGLE_LOADING_COMPLEX_MENU:
      return {
        ...state,
        isLoadingComplexes: !state.isLoadingComplexes,
      };
    case constants.SET_FOOD_CORSE_SELECTED_COMPLEX:
      return {
        ...state,
        selectedComplex: {
          ...state.selectedComplex,
          foodCourse: action.payload.foodCourse,
        },
      };
    case constants.IS_SHOW_DELETE_POPUP:
      return {
        ...state,
        isShowDeletePopup: true,
        deletingComplexId: action.payload.id,
        deletingComplexName: action.payload.name,
      };
    case constants.IS_SHOW_DELETE_POPUP_CANCELED:
      return {
        ...state,
        isShowDeletePopup: false,
        deletingComplexId: '',
        deletingComplexName: '',
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/complex.js